<div class="confirm">
  <h1 mat-dialog-title> {{title}} </h1>
  
  <div mat-dialog-content> {{message}}</div>
  
  <div mat-dialog-actions class="action">
    
    <button mat-stroked-button color="basic" (click)="onDismiss()">Cancel</button>


    <div class="signature">
      <button mat-stroked-button class="finish"  (click)="WithoutFolder()">Without Folder</button>&nbsp;&nbsp;
      <button mat-stroked-button class="finish"  (click)="CreateNewFolder()">Create new folder</button>      
    </div>
  </div>

</div>



